import React, { createContext, useContext, useEffect, useState } from 'react';
import { CartServicesReactReadyHelper } from '../drawCartServices';

const MINICART_TOGGLE = 'minicart-toggle';

interface MinicartUiContextInterface {
  isOpen: boolean;
}

export const MinicartUiContext = createContext<MinicartUiContextInterface>(null);

export const MinicartUiContextProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleToggle = (event: CustomEvent) => {
    if (event.detail.isOpen !== undefined && event.detail.isOpen !== null) setIsOpen(event.detail.isOpen);
  };

  useEffect(() => {
    window.addEventListener(MINICART_TOGGLE, handleToggle);
    CartServicesReactReadyHelper.setIsReady(true);
    return () => {
      window.removeEventListener(MINICART_TOGGLE, handleToggle);
    };
  });

  return <MinicartUiContext.Provider value={{ isOpen }}>{children}</MinicartUiContext.Provider>;
};

export class MinicartUiContextHelper {
  static toggle = (isOpen: boolean) => {
    if (!CartServicesReactReadyHelper.getIsReady()) {
      setTimeout(() => MinicartUiContextHelper.toggle(isOpen), 50);
    } else {
      window.dispatchEvent(new CustomEvent(MINICART_TOGGLE, { detail: { isOpen } }));
    }
  };
}

export const useMinicartUiContext = () => {
  const context = useContext(MinicartUiContext);
  if (context === undefined || context === null) {
    throw 'useMinicartUiContext must be used within a MinicartUiContextProvider';
  }
  return context;
};
